export default "__VITE_ASSET__DHUeDGfH__"